import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faKey, faHome, faChartLine, faComments, faTools, faUsers, faCity, faHandshake, faMapMarkerAlt, faStar, faQuoteLeft, faUserTie, faHouseUser, faAward } from '@fortawesome/free-solid-svg-icons';

function Home() {

  const navigate = useNavigate();

  const handleRedirect = (path) => {
    navigate(path);
  };

  return (
    <div className="presentation-container">
      {/* Hero Section */}
      <div className="hero-section" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/hero-villa.jpg)` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Votre partenaire de <span className="hero-highlight">confiance</span> pour la <span className="hero-highlight">gestion</span> et la <span className="hero-highlight">vente</span> immobilière au Sénégal</h1>
          <a href="/confier-mon-bien" className="hero-cta">Confier mon bien</a>
        </div>
      </div>

      <div className="section about-us">
        <h2>À propos de nous</h2>
        <p>
          Cabinet Immobilier et de Consultance Juridique (CICJ) est une agence immobilière basée à Thiès, au Sénégal. Nous
          sommes spécialisés dans la gérance, les locations, les ventes, ainsi que dans les études et expertises, la consultance et le BTP. Notre équipe
          dévouée est prête à vous accompagner dans tous vos projets immobiliers
          à Dakar, Thiès et dans plusieurs zones au Sénégal.
        </p>
      </div>

      <div className="section services">
        <h2>Nos Services</h2>
        <div className="services-grid">
          <div className="service-card" onClick={() => handleRedirect('/louer')}>
            <FontAwesomeIcon icon={faKey} className="service-icon-presentation" />
            <h3>Louer</h3>
            <p>
              Que vous soyez locataire ou propriétaire, nous vous aidons à
              trouver ou à louer des biens de qualité.
            </p>
          </div>
          <div className="service-card" onClick={() => handleRedirect('/acheter')}>
            <FontAwesomeIcon icon={faHome} className="service-icon-presentation" />
            <h3>Acheter</h3>
            <p>
              Nous vous accompagnons dans l'achat de vos biens
              immobiliers, avec un service personnalisé.
            </p>
          </div>
          <div className="service-card" onClick={() => handleRedirect('/confier-mon-bien')}>
            <FontAwesomeIcon icon={faBuilding} className="service-icon-presentation" />
            <h3>Confier mon bien</h3>
            <p>
              Nous assurons la gestion complète de vos biens immobiliers avec
              professionnalisme et transparence.
            </p>
          </div>
          <div className="service-card" onClick={() => handleRedirect('/projet-immobilier')}>
            <FontAwesomeIcon icon={faChartLine} className="service-icon-presentation" />
            <h3>Projet immobilier</h3>
            <p>
              Nos experts réalisent des études approfondies et des expertises
              pour garantir la valeur de votre investissement.
            </p>
          </div>
          <div className="service-card" onClick={() => handleRedirect('/conseils-consultance')}>
            <FontAwesomeIcon icon={faComments} className="service-icon-presentation" />
            <h3>Conseils & Consultance</h3>
            <p>
              Nous offrons des services de consultation pour vous guider dans
              vos décisions immobilières.
            </p>
          </div>
          <div className="service-card" onClick={() => handleRedirect('/btp-construction')}>
            <FontAwesomeIcon icon={faTools} className="service-icon-presentation" />
            <h3>BTP & Construction</h3>
            <p>
              Notre équipe BTP est à votre service pour tous vos projets de
              construction et de rénovation.
            </p>
          </div>
        </div>
      </div>

      {/* Chiffres clés */}
      <div className="section key-figures">
        <h2>Nos Chiffres Clés</h2>
        <div className="figures-grid">
          <div className="figure-card">
            <FontAwesomeIcon icon={faUsers} className="figure-icon" />
            <h3>1 000+</h3>
            <p>Clients accompagnés</p>
          </div>
          <div className="figure-card">
            <FontAwesomeIcon icon={faCity} className="figure-icon" />
            <h3>50 à 100</h3>
            <p>Biens en gestion active</p>
          </div>
          <div className="figure-card">
            <FontAwesomeIcon icon={faHandshake} className="figure-icon" />
            <h3>50</h3>
            <p>Bailleurs accompagnés</p>
          </div>
          <div className="figure-card">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="figure-icon" />
            <h3>Dakar, Thiès</h3>
            <p>Et plusieurs zones au Sénégal</p>
          </div>
        </div>
      </div>

      {/* Témoignages */}
      <TestimonialsSection />

      <div className="section locations">
        <h2>Nos Emplacements</h2>
        <p>
          Nous intervenons principalement à Thiès (Mbour 4, Centre-ville, Zac Ba…), à Dakar (Maristes, Sacré-Cœur, Liberté 6, Almadies…) ainsi que dans la zone de Mbour et la Petite Côte (Mbour, Saly, Somone, Ngaparou, Sindia).
        </p>
      </div>

      <div className="section contact">
        <h2>Contactez-nous</h2>
        <p>
          N'hésitez pas à nous contacter pour toute question ou pour discuter de
          vos projets immobiliers. Notre équipe est à votre écoute.
        </p>
        <a href="/contact" className="contact-button">Contactez-nous</a>
      </div>
    </div>
  );
}

/* ============ Composant Témoignages ============ */
const allTestimonials = [
  // Bailleurs
  { name: 'M. Diallo', role: 'Bailleur', location: 'Sindia', text: 'Je suis satisfait de la gestion de mon bien. Le suivi est sérieux et les loyers sont bien encadrés.', category: 'bailleur' },
  { name: 'Mme Sarr', role: 'Bailleur', location: 'Cité Mixta, Dakar', text: 'Le cabinet assure une gestion claire et transparente. Je suis régulièrement informée.', category: 'bailleur' },
  { name: 'M. Ba', role: 'Bailleur', location: 'Grand Mbao', text: 'Bonne organisation et bon suivi. Le cabinet gère correctement les locataires.', category: 'bailleur' },
  { name: 'M. Ndiaye', role: 'Bailleur', location: 'Keur Massar', text: 'Gestion structurée avec un bon encadrement. Je suis rassuré par leur sérieux.', category: 'bailleur' },
  { name: 'Mme Faye', role: 'Bailleur', location: 'Thiès', text: 'Service professionnel avec un bon accompagnement. Le cabinet reste disponible.', category: 'bailleur' },
  { name: 'M. Diagne', role: 'Bailleur', location: 'Ngaparou', text: 'Bonne gestion avec un suivi régulier. Le service est fiable.', category: 'bailleur' },
  // Locataires
  { name: 'M. Sy', role: 'Locataire', location: 'Mbour 4, Thiès', text: "Le suivi est sérieux et la communication est bonne. Tout s'est bien passé depuis mon installation.", category: 'locataire' },
  { name: 'Mme Fall', role: 'Locataire', location: 'Liberté 6, Dakar', text: 'Service professionnel avec un bon encadrement. Les échanges sont clairs.', category: 'locataire' },
  { name: 'M. Sow', role: 'Locataire', location: 'Keur Massar', text: 'Gestion simple et bien organisée. Je suis satisfait du service.', category: 'locataire' },
  { name: 'M. Gueye', role: 'Locataire', location: 'Grand Yoff, Dakar', text: 'Bonne organisation et respect des engagements.', category: 'locataire' },
  { name: 'Mme Ndiaye', role: 'Locataire', location: 'Cité Mixta, Dakar', text: 'Très satisfaite du service et de la disponibilité du cabinet.', category: 'locataire' },
  { name: 'M. Thiam', role: 'Locataire', location: 'Thiès', text: 'Bonne gestion avec un suivi régulier. Le service est sérieux.', category: 'locataire' },
  { name: 'M. Seck', role: 'Locataire', location: 'Sindia', text: "Expérience positive. L'équipe reste disponible en cas de besoin.", category: 'locataire' },
];

function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 1 carte en mobile, 3 en desktop
  const visibleCount = isMobile ? 1 : 3;
  const total = allTestimonials.length;

  const goNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % total);
  }, [total]);

  const goPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + total) % total);
  };

  // Défilement automatique
  useEffect(() => {
    if (showAll || isPaused) return;
    const interval = setInterval(goNext, 4000);
    return () => clearInterval(interval);
  }, [showAll, isPaused, goNext]);

  // Récupérer les éléments visibles (circulaire)
  const getVisibleItems = () => {
    const items = [];
    for (let i = 0; i < visibleCount; i++) {
      items.push(allTestimonials[(currentIndex + i) % total]);
    }
    return items;
  };

  const renderCard = (t, idx) => (
    <div className="testimonial-card" key={idx}>
      <FontAwesomeIcon icon={faQuoteLeft} className="quote-icon" />
      <p className="testimonial-text">"{t.text}"</p>
      <div className="testimonial-author">
        {[...Array(5)].map((_, i) => (
          <FontAwesomeIcon icon={faStar} className="star-icon" key={i} />
        ))}
      </div>
      <p className="testimonial-name">— {t.name}</p>
      <p className="testimonial-role">{t.role} ({t.location})</p>
      <span className={`testimonial-badge ${t.category}`}>
        <FontAwesomeIcon icon={t.category === 'bailleur' ? faUserTie : faHouseUser} style={{ marginRight: 6 }} />
        {t.category === 'bailleur' ? 'Bailleur' : 'Locataire'}
      </span>
    </div>
  );

  return (
    <div className="section testimonials">
      <h2><FontAwesomeIcon icon={faAward} style={{ color: '#007bff', marginRight: 8 }} />Ils nous font confiance</h2>

      {!showAll ? (
        <>
          <div
            className="testimonials-carousel"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            <button className="carousel-btn prev" onClick={goPrev} aria-label="Précédent">❮</button>
            <div className="testimonials-track">
              {getVisibleItems().map((t, i) => renderCard(t, i))}
            </div>
            <button className="carousel-btn next" onClick={goNext} aria-label="Suivant">❯</button>
          </div>
          <div className="carousel-dots">
            {allTestimonials.map((_, i) => (
              <span
                key={i}
                className={`dot ${i === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(i)}
              />
            ))}
          </div>
          <button className="see-all-btn" onClick={() => setShowAll(true)}>
            Voir tous les témoignages ({total})
          </button>
        </>
      ) : (
        <>
          <div className="testimonials-category">
            <h3><FontAwesomeIcon icon={faUserTie} style={{ marginRight: 8 }} />Bailleurs</h3>
            <div className="testimonials-grid-all">
              {allTestimonials.filter(t => t.category === 'bailleur').map((t, i) => renderCard(t, i))}
            </div>
          </div>
          <div className="testimonials-category">
            <h3><FontAwesomeIcon icon={faHouseUser} style={{ marginRight: 8 }} />Locataires</h3>
            <div className="testimonials-grid-all">
              {allTestimonials.filter(t => t.category === 'locataire').map((t, i) => renderCard(t, i))}
            </div>
          </div>
          <button className="see-all-btn" onClick={() => setShowAll(false)}>
            Réduire
          </button>
        </>
      )}
    </div>
  );
}

export default Home;